import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import SectionCard from '../common/cards/SectionCard';

const DataOnWorkersHealth = props => {
	
	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L20916 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	return(
		<div className="data-workers-health">
			<AdviceSection literals={ props.literals } section={["accidents-diseases-well-being","data-workers-health"]} methodologyData={{section: 'accidents-diseases-well-being', subsection: 'Health perception of the workers', indicator: 57}} />
			<section className="container-fluid background-gray section--page ">
				<div className="container">
					<h2 className="title-section second-color">{ props.literals.L20708 }</h2>
					<section className="card--grid xxs-w1 w3 center-text">
						<SectionCard
							iconClass = "health-icon"
							link = "/accidents-diseases-well-being/data-on-workers-health/health-perception"
							title = { props.literals.L22011 }
							text = { props.literals.L22052 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "health-compared-peers-icon"
							link = "/accidents-diseases-well-being/data-on-workers-health/health-compared-to-peers"
							title = { props.literals.L20919 }
							text = { props.literals.L20920 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "reported-health-problems-icon"
							link = "/accidents-diseases-well-being/data-on-workers-health/reported-health-problems/general"
							title = { props.literals.L20928 }
							text = { props.literals.L20929 }
							seeMore = { props.literals.L480 }
						/>
					</section>
				</div>
			</section>
		</div>
	)
}

DataOnWorkersHealth.displayName = 'DataOnWorkersHealth';
export default DataOnWorkersHealth;